import Grid from '@mui/material/Grid'
import { ShiftTeam, useShiftTeams } from 'api/shiftTeams/shiftTeams.api'
import moment from 'moment'
import React, { ReactElement, useState } from 'react'
import StatusComponent from 'ui/components/StatusComponent/StatusComponent'
import ShiftInfoCalendar from './components/ShiftInfoCalendar/ShiftInfoCalendar'
import ShiftInfoTeamList from './components/ShiftInfoTeamList/ShiftInfoTeamList'
import styles from './ShiftInfoWidget.module.less'

function Wrapper({ shiftTeams }: { shiftTeams: ShiftTeam[] }): ReactElement {
  const [currentDate, setCurrentDate] = useState(moment().startOf(`isoWeek`))

  return (
    <>
      <Grid
        className={styles.ShiftInfoWidget_ShiftAchievements}
        size={{
          xs: 6,
          md: 3,
        }}
      >
        <ShiftInfoTeamList shiftTeams={shiftTeams} />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 9,
        }}
      >
        <ShiftInfoCalendar shiftTeams={shiftTeams} currentDate={currentDate} setCurrentDate={setCurrentDate} />
      </Grid>
    </>
  )
}

export default function ShiftInfoWidget(): ReactElement {
  const { data: shiftTeams, status } = useShiftTeams()

  return (
    <Grid container direction="row" justifyContent="center" className={styles.ShiftInfoWidget_ShiftInBox}>
      <StatusComponent data={{ shiftTeams }} status={status} Component={Wrapper} />
    </Grid>
  )
}
